import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardFooter, Row, Col, Button, Label, Input } from "reactstrap";

// styles ccs
import "assets/css/efeitoCards.css";

//Api
import { api_GET, api_POST } from '../../services/api_service';

//Helpers
import { formateDateApi } from '../../helpers/formats';
import { showMessage } from "../../services/message.js";

//Components
import ListaDashboardRequerimento from './ListaDashboardRequerimento';
import TextField from '../../components/TextField/TextField';

//Context
import { useAuth } from '../../context/auth';

function initialStateFiltro() {
    return {
        modalidade: "Todos"
    }
}
function Dashboard() {
    const {setLoading, loading} = useAuth();

    // Estado para o botão de aparecer fitros de Data
    const [btnfiltro, setBtnFiltro] = useState(false);

    // Estado para pegar a lista de protocolos
    const [dashboardProtocolo, setDashboardProtocolo] = useState(null);

    // Estado para pegar a lista de requerimentos
    const [dashboardRequerimento, setDashboardRequerimento] = useState(null);

    // Estado para controlar os indicadores
    const [mostrarTotalIndicadores, setMostrarTotalIndicadores] = useState(true);

    // Estado auxiliar para guardar valores dos protocolos e requerimentos
    const [dashboardAuxiliar, setDashboardAuxiliar] = useState(
        {
            dashboardProtocolo: null,
            dashboardRequerimento: null
        }
    );

    // Estado para abrir as informaçoes de cada indicador
    const [visibleDadosIndicadores, setVisibleDadosIndicadores] = useState({
        index: '',
        tipoIndicador: ''
    });

    // Estado para mostrar component da lista dos requerimentos
    const [listShow, setListShow] = useState(null);

    // Estado para para pegar a modalidade
    const [filtro, setFiltro] = useState(initialStateFiltro());

    // Estado para options de modalidade
    const [optionsModalidade, setOptionsModalidade] = useState([
        { text: "Todos", value: "Todos" },
        { text: "RCC", value: "RCC" },
        { text: "RGG", value: "RGG" },
        { text: "RSS", value: "RSS" },
    ]);


    useEffect(() => {
        setLoading(true);
        api_GET('Dashboard/protocolos')
            .then(result => {
                setDashboardAuxiliar({
                    ...dashboardAuxiliar,
                    dashboardProtocolo: result.data
                })
                setDashboardProtocolo(result.data);
            })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }, []);

    // função para marcar qual card abrir
    const handleVisibleDadosIndicadores = (index, tipoIndicador) => {
        setMostrarTotalIndicadores(!mostrarTotalIndicadores)
        setVisibleDadosIndicadores(
            {
                index: index,
                tipoIndicador: tipoIndicador
            }
        )
    }

    // altera texto apresentando no cards
    const HandleModificarTextoCardIndicador = (obj, tipo) => {
        let total = 0;
        if (tipo === "requerimento") {
            total = (obj.qtdFinalizado + obj.qtdPendente + obj.qtdEmAndamento + obj.qtdRejeitado)
        } else {
            total = obj.tiposProtocolos.reduce((acc, tipo) => acc + tipo.qtdAtivos + tipo.qtdInativos + tipo.qtdCancelados + tipo.qtdVencidos, 0);
        }

        return {
            texto: obj.descricaoDashboard,
            color: obj.corIcone,
            icone: obj.classeIcone,
            total: total
        }
    }

    // montar card Cadastro dos protocolos
    const CardsCadastroIndicativo = ({ cadastro, index }) => {
        const dado = HandleModificarTextoCardIndicador(cadastro, "cadastro");

        return (
            <>
                <Col lg="3" md="6" sm="6">
                    <Card className="card-stats card-dash">
                        <CardBody className="p-4">
                            <Row className="d-flex align-items-center justify-content-between">
                                <Col md="7" sm="8">
                                    <i className={`${dado?.icone} ${dado?.color} fa-4x`}></i>
                                </Col>
                                <Col md="5" sm="4">
                                    <span style={{ fontSize: '18px', display: 'block' }} className="px-2">{dado?.total}</span>
                                </Col>
                            </Row>
                        </CardBody>
                        <CardFooter className="p-0">
                            <Button className="w-100" color={"primary"} onClick={() => handleVisibleDadosIndicadores(index, "cadastro")}>
                                <div className="d-flex justify-content-between">
                                    <div>
                                        <span className='display-5'>{dado?.texto}</span>
                                    </div>
                                    <div>
                                        {mostrarTotalIndicadores && visibleDadosIndicadores.index == index && visibleDadosIndicadores.tipoIndicador === "cadastro" ? <i className="fas fa-angle-up"></i> : <i className="fas fa-angle-down"></i>}
                                    </div>
                                </div>
                            </Button>

                            <div className={`visible ${mostrarTotalIndicadores && visibleDadosIndicadores.index == index && visibleDadosIndicadores.tipoIndicador === "cadastro" ? ' pl-4 py-2 w-100' : 'invisible'}`}>
                                {cadastro.tiposProtocolos && cadastro.tiposProtocolos.map((el, index) => (
                                    <Row key={index} className="mb-2">
                                        <Col md={12} className="mb-2">
                                            PESSOA {el.tipoPessoa}
                                        </Col>
                                        <Col md={8} sm={10}>
                                            ATIVOS:
                                        </Col>
                                        <Col md={4} sm={2}>
                                            {el.qtdAtivos}
                                        </Col>
                                        <Col md={8} sm={10}>
                                            CANCELADOS:
                                        </Col>
                                        <Col md={4} sm={2}>
                                            {el.qtdCancelados}
                                        </Col>
                                        <Col md={8} sm={10}>
                                            INATIVOS:
                                        </Col>
                                        <Col md={4} sm={2}>
                                            {el.qtdInativos}
                                        </Col>
                                        <Col md={8} sm={10}>
                                            VENCIDOS:
                                        </Col>
                                        <Col md={4} sm={2}>
                                            {el.qtdVencidos}
                                        </Col>
                                    </Row>
                                ))}
                            </div>
                        </CardFooter>
                    </Card>
                </Col>
            </>
        );
    }

    // montar card Cadastro dos Requerimento
    const CardsRequerimentoIndicativo = ({ requerimento, index }) => {
        const dadoRequerimento = HandleModificarTextoCardIndicador(requerimento, "requerimento");
        return (
            <>
                <Col lg="3" md="6" sm="6">
                    <Card className="card-stats card-dash">
                        <CardBody className="p-4">
                            <Row className="d-flex align-items-center justify-content-between">
                                <Col md="7" sm="8">
                                    <i className={`${dadoRequerimento.icone} ${dadoRequerimento.color} fa-4x`}></i>
                                </Col>
                                <Col md="5" sm="4">
                                    <span style={{ fontSize: '18px', display: 'block' }} className="px-2">{dadoRequerimento.total}</span>
                                </Col>
                            </Row>
                        </CardBody>
                        <CardFooter className="p-0">
                            <Button className="w-100" color={"primary"} onClick={() => handleVisibleDadosIndicadores(index, "requerimento")}>
                                <div className="d-flex justify-content-between">
                                    <div>
                                        {dadoRequerimento.texto}
                                    </div>
                                    <div>
                                        {mostrarTotalIndicadores && visibleDadosIndicadores.index == index && visibleDadosIndicadores.tipoIndicador === "requerimento" ? <i className="fas fa-angle-up"></i> : <i className="fas fa-angle-down"></i>}
                                    </div>
                                </div>
                            </Button>
                            <div className={`visible ${mostrarTotalIndicadores && visibleDadosIndicadores.index == index && visibleDadosIndicadores.tipoIndicador === "requerimento" ? 'py-2 w-100' : 'invisible'}`}>
                                <div className="hoverInfo d-flex flex-column justify-content-between align-items-center">
                                    <div className='w-100 d-flex justify-content-between align-items-center px-2 py-1' onClick={() => setListShow({
                                        requerimentos: requerimento,
                                        categoria: dadoRequerimento.texto,
                                        etapa: "Em Andamento",
                                        segmento: requerimento.segmento,
                                        descricao: requerimento.descricao,
                                        sigla: requerimento.sigla
                                    })}>
                                        <span>Em Andamento:</span>
                                        <span className='mr-4'>{requerimento.qtdEmAndamento}</span>
                                    </div>
                                    <div className='w-100 d-flex justify-content-between align-items-center px-2 py-1' onClick={() => setListShow(
                                        {
                                            requerimentos: requerimento,
                                            categoria: dadoRequerimento.texto,
                                            etapa: "Finalizado",
                                            segmento: requerimento.segmento,
                                            descricao: requerimento.descricao,
                                            sigla: requerimento.sigla
                                        }
                                    )}>
                                        <span>Finalizado:</span>
                                        <span className='mr-4'>{requerimento.qtdFinalizado}</span>
                                    </div>
                                    <div className='w-100 d-flex justify-content-between align-items-center px-2 py-1' onClick={() => setListShow({
                                        requerimentos: requerimento,
                                        categoria: dadoRequerimento.texto,
                                        etapa: "Pendente",
                                        segmento: requerimento.segmento,
                                        descricao: requerimento.descricao,
                                        sigla: requerimento.sigla
                                    })}>
                                        <span>Pendente:</span>
                                        <span className='mr-4'>{requerimento.qtdPendente}</span>
                                    </div>
                                    <div className='w-100 d-flex justify-content-between align-items-center px-2 py-1' onClick={() => setListShow({
                                        requerimentos: requerimento,
                                        categoria: dadoRequerimento.texto,
                                        etapa: "Rejeitado",
                                        segmento: requerimento.segmento,
                                        descricao: requerimento.descricao,
                                        sigla: requerimento.sigla
                                    })}>
                                        <span>Rejeitado:</span>
                                        <span className='mr-4'>{requerimento.qtdRejeitado}</span>
                                    </div>
                                </div>
                            </div>
                        </CardFooter>
                    </Card>
                </Col>
            </>
        );
    }

    const [dadoFiltro, setDadoFiltro] = React.useState({
        datainicio: '',
        datafim: ''
    })
    // pegando os dados campos de data
    const handleDataFiltros = (event) => {
        setDadoFiltro(
            {
                ...dadoFiltro,
                [event.target.name]: event.target.value
            }
        )
    }

    // filtro de pegar os dados na Api
    const handleFiltroIndicadores = () => {
        if (dadoFiltro.datafim === "" || dadoFiltro.datafim === "") {
            showMessage("Aviso", "Os campos de Data devem está preenchido!", "warning", null);
            return;
        }
        const json_submit = {
            Inicio: formateDateApi(dadoFiltro.datainicio),
            Fim: formateDateApi(dadoFiltro.datafim)
        }
        setLoading(true);
        api_POST('Dashboard/requerimentos', json_submit).then(result => {
            setDashboardAuxiliar({
                ...dashboardAuxiliar,
                dashboardRequerimento: result.data
            });

            if (filtro.modalidade != "Todos") {
                setDashboardRequerimento({ requerimentos: result.data?.requerimentos?.filter(x => x.sigla == filtro.modalidade) });
            }
            else
                setDashboardRequerimento(result.data);
        })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    //voltar para dashboard
    const handleReturnDashboard = () => {
        setVisibleDadosIndicadores({
            index: '',
            tipoIndicador: ''
        })
        setLoading(false);
        setListShow(null);
    }

    const handleFiltroModalidade = (e) => {
        const { name, value } = e.target;
        setFiltro({
            ...filtro,
            [name]: value
        });
    }

    useEffect(() => {
        if (filtro?.modalidade != "Todos") {
            setDashboardProtocolo({
                protocolos: dashboardAuxiliar.dashboardProtocolo?.protocolos?.length > 0 ? dashboardAuxiliar.dashboardProtocolo?.protocolos.filter(x => x.sigla == filtro?.modalidade) : []
            });
            setDashboardRequerimento({
                requerimentos: dashboardAuxiliar.dashboardRequerimento?.requerimentos?.length > 0 ? dashboardAuxiliar.dashboardRequerimento?.requerimentos?.filter(x => x.sigla == filtro?.modalidade) : []
            });
        } else {
            setDashboardProtocolo(dashboardAuxiliar.dashboardProtocolo)
            setDashboardRequerimento(dashboardAuxiliar.dashboardRequerimento)
        }
    }, [filtro]);

    return (
        <>
            {!loading && listShow === null &&
                <div className='content'>
                    <Row className="d-flex justify-content-end align-items-center">
                        <Col lg={3}>
                            <TextField
                                name={"modalidade"}
                                label={<span className="text-white">Modalidades</span>}
                                type={"select"}
                                options={optionsModalidade}
                                value={filtro.modalidade}
                                onChange={handleFiltroModalidade}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Card className="titulo-dash">
                            {dashboardProtocolo && dashboardProtocolo.protocolos.length > 0 &&
                                <>
                                    <Row>
                                        <Col lg={12} md={12}>
                                            <h6 className="p-1">
                                                Cadastros
                                            </h6>
                                        </Col>
                                    </Row>

                                    <div className="card-principal">
                                        <Row>
                                            {dashboardProtocolo.protocolos.map((cadastro, index) => (
                                                <CardsCadastroIndicativo
                                                    key={index}
                                                    cadastro={cadastro}
                                                    index={index}
                                                />
                                            ))}
                                        </Row>
                                    </div>
                                </>
                            }

                            <Row>
                                <Col lg={12} md={12}>
                                    <h6 className="px-2">
                                        Requerimentos
                                    </h6>
                                </Col>
                            </Row>

                            <div className='d-flex justify-content-end'>
                                <Button color="primary" onClick={() => setBtnFiltro(!btnfiltro)}>
                                    <i className="fas fa-filter mr-2"></i>
                                    Filtro
                                </Button>
                            </div>

                            {btnfiltro &&
                                <Row className="mb-4 d-flex align-items-end px-2">
                                    <Col lg={4}>
                                        <Label for="DataInicial" className={"text-danger"}>
                                            * Data Início
                                        </Label> <br />
                                        <Input
                                            id="DataInicial"
                                            name="datainicio"
                                            placeholder="date placeholder"
                                            type="date"
                                            value={dadoFiltro.datainicio}
                                            onChange={(e) => handleDataFiltros(e)}
                                        />
                                    </Col>
                                    <Col lg={4}>
                                        <Label for="DataFim" className={"text-danger"}>
                                            * Data Fim
                                        </Label> <br />
                                        <Input
                                            id="DataFim"
                                            name="datafim"
                                            placeholder="date placeholder"
                                            type="date"
                                            value={dadoFiltro.datafim}
                                            onChange={(e) => handleDataFiltros(e)}
                                        />
                                    </Col>
                                    <Col lg={2} >
                                        <Button color="success" style={{ marginBottom: '0px' }} onClick={handleFiltroIndicadores}>
                                            <i className="fas fa-search mr-2"></i>
                                            Filtro
                                        </Button>
                                    </Col>
                                </Row>
                            }

                            {dashboardRequerimento && dashboardRequerimento.requerimentos.length > 0 &&
                                <>
                                    <div className="card-principal">
                                        <Row>
                                            {dashboardRequerimento.requerimentos.map((requerimento, index) => (
                                                <CardsRequerimentoIndicativo key={index} requerimento={requerimento} index={index} />
                                            ))}
                                        </Row>
                                    </div>
                                </>
                            }
                        </Card>
                    </Row>
                </div>
            }
            {listShow &&
                <ListaDashboardRequerimento listShow={listShow} handleReturnDashboard={handleReturnDashboard} />
            }
        </>
    );
}

export default Dashboard;